import { trans } from '@spotahome/soyuz/client';
import { SharingMethods } from '@spotahome/ui-library';

import { getReferrerLink } from './utils';

const { whatsapp, email, facebook, twitter } = SharingMethods.types;

const sharingLinkGenerators = {
  [whatsapp]: ({ code, queryParams }) => {
    const message = `${trans(
      'referrals.dashboard.send-your-link.message.part-1'
    )} ${trans(
      'referrals.dashboard.send-your-link.message.part-2'
    )} ${getReferrerLink({
      code,
      params: queryParams
    })}`;
    const encodedText = encodeURIComponent(message);
    return `https://api.whatsapp.com/send?text=${encodedText}`;
  },
  [email]: ({ code, queryParams, userName }) => {
    const subject = trans('referrals.dashboard.send-your-link.email-subject', {
      name: userName
    });
    const message = `${trans(
      'referrals.dashboard.send-your-link.message.part-1'
    )}%0D%0D${trans(
      'referrals.dashboard.send-your-link.message.part-2'
    )} ${getReferrerLink({
      code,
      params: queryParams
    })}`;
    return `mailto:?subject=${subject}&body=${message}`;
  },
  [twitter]: ({ code, queryParams }) => {
    const message = trans('referrals.dashboard.share-your-link.message');
    const link = getReferrerLink({ code, params: queryParams });
    return `https://twitter.com/intent/tweet?text=${message}&url=${link}`;
  },
  [facebook]: ({ code, queryParams }) => {
    const message = encodeURI(
      trans('referrals.dashboard.share-your-link.message')
    );
    const link = getReferrerLink({ code, params: queryParams });
    return `https://www.facebook.com/sharer/sharer.php?quote=${message}&u=${link}`;
  }
};

export default sharingLinkGenerators;
